import { API } from '../App';

let deviceId = localStorage.getItem('fray_device_id');
if (!deviceId) {
  deviceId = crypto.randomUUID();
  localStorage.setItem('fray_device_id', deviceId);
}

export function trackEvent(eventName, properties = {}) {
  API.post('/api/analytics/event', {
    event_name: eventName,
    device_id: deviceId,
    properties,
  }).catch(() => {});
}

export { deviceId };
